import {FC} from "react";
import {FullPageSpinner} from "../../components/loading/Spinner";
import {Navigate} from "react-router-dom";
import {useParams} from "react-router";
import {IntegrationApp, isValidIntegrationApp} from "./app-names";

export type PostAuthMessage = {
 isError: boolean,
 appName: IntegrationApp,
 oauth_response: {
  access_token: string,
  expires_in: number,
  token_type: string,
 }
}

export const PostAuthPage: FC = () => {
 const params = useParams();
 const appName = (params.app_name || "") as IntegrationApp;
 if (!isValidIntegrationApp(appName)) {
  return <Navigate to="/error"/>
 }

 const message : PostAuthMessage = {
  isError: true,
  appName,
  oauth_response: {
   access_token: "",
   expires_in: 0,
   token_type: "",
  }
 };
 let openerURI = "";
 if (window.location.hash) {
  const hash = window.location.hash.substring(1);
  const searchParams = new URLSearchParams(hash);
  openerURI = searchParams.get("state") || "";
  message.oauth_response.access_token = searchParams.get("access_token") || "";
  message.oauth_response.expires_in = Number(searchParams.get("expires_in") || "");
  message.oauth_response.token_type = searchParams.get("token_type") || "";
  message.isError = !(!!message.oauth_response.access_token &&
      message.oauth_response.expires_in > 0 &&
      !!message.oauth_response.token_type && !!openerURI);
 }
 if (!message.isError && window.opener) {
  window.opener.postMessage(message, openerURI);
  window.close();
 }
 if (message.isError) {
  return <Navigate to="/error"/>
 }
 return <FullPageSpinner/>
};
